import { toPercent } from "../../../utils/values";

export const isEqual = (a: number, b: number, { epsilon }: { epsilon: number }): boolean => Math.abs(a - b) < epsilon;

export function getIsMarkActive(markValue: React.Key | null | undefined, value: number | number[] = 0): boolean {
  if (typeof markValue !== "number") {
    return false;
  }

  if (typeof value === "number") {
    return markValue <= value;
  }

  return value[0] <= markValue && markValue <= value[value.length - 1];
}

export function getIsTrackActive(index: number, value: number | number[] = 0): boolean {
  if (typeof value === "number") {
    return index === 0;
  }

  return index > 0 && index < value.length;
}

export const defaultValueFormatter = (value: number, { min, max }: { min: number; max: number } = { min: 0, max: 100 }) => toPercent(Math.round((value * 100) / (max - min)));

export const getDefaultMarks = (min: number, max: number) => {
  const range = max - min;

  return [min, min + range / 4, min + range / 2, min + (range * 3) / 4, max];
};
